// TODO(@): Shift to @cleartrip/ct-design

import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'

import { normalizeSize } from '@/utils/general/uiHelper'

import cssStyles from './Stencil.module.scss'

interface IStencilProps {
    /**
     * Additional classes to be added to the component
     */
    className?: string
    /**
     * Height of the stencil
     */
    height?: string | number
    /**
     * Width of the stencil
     */
    width?: string | number
    /**
     * Either a block or inline
     */
    type?: string
    /**
     * Adds a shimmer to the placeholders
     */
    shimmer?: boolean
    /**
     * Invert colors of stencil for dark backgrounds
     */
    dark?: boolean
    /**
     * Rounded border
     */
    borderRadius?: string | number
}

const Stencil = ({
    children = null,
    className = '',
    height = '100',
    width = '100',
    type = 'block',
    shimmer = false,
    dark = false,
    borderRadius = 0
}: PropsWithChildren<IStencilProps>) => {
    const styles = {
        width: normalizeSize(width),
        height: normalizeSize(height),
        borderRadius: normalizeSize(borderRadius || 0)
    }
    const classes = classNames(className, {
        [cssStyles.stencil]: true,
        [cssStyles.hasShimmer]: shimmer,
        [cssStyles.isRounded]: type === 'rounded',
        [cssStyles.isCircular]: type === 'circular',
        [cssStyles.isDark]: dark === true
    })

    return (
        <div className={classes} style={styles}>
            {children}
        </div>
    )
}

export { Stencil }
